import { ChartLineIcon as PhosphorChartLineIcon } from "@phosphor-icons/react/dist/ssr/ChartLine";

import { createAppIcon } from "@/components/createAppIcon";

export const MonitoringIcon = /* @__PURE__ */ createAppIcon(PhosphorChartLineIcon);
export const TrendChartIcon = /* @__PURE__ */ createAppIcon(PhosphorChartLineIcon);
